import React, { Component } from 'react'
import PropTypes from 'prop-types'
import uuid from 'uuid'
import {
  AddUserPreparationTraining
} from 'containers/forms/aj-preparation-trainings/index'
import { Modal } from 'containers/misc/index'
import { Title } from 'components/layout/index'
import { Button } from 'components/misc/index'
import {
  AwardPreparationTrainingsTable
} from 'components/sections/awards/index'

export default class AwardUsersPreparationTrainings extends Component {
  static propTypes = {
    awardId: PropTypes.number,
    collection: PropTypes.array.isRequired,
    list: PropTypes.array,
    addPreparationTraining: PropTypes.func.isRequired,
    removePreparationTraining: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired
  }

  state = {
    idToRemove: null
  }

  key = uuid.v1()

  handleRemoveModal = idToRemove => {
    this.setState(
      {
        idToRemove
      },
      () => this.props.modal(`remove-preparation-training-${this.key}`)
    )
  }

  render() {
    const { list, collection, awardId } = this.props

    return (
      <div>
        <div style={{ width: '98%', margin: 'auto' }}>
        <div className="row">
          <div className="col-xs-8">
            <Title h2 intlKey="moduleTitle.user_added_preparation_and_training">
              User Added Preparation and Training
            </Title>
          </div>
          <div className="col-xs-4 text--right">
            {awardId &&
              <Button
                type="button"
                intlKey="button.add"
                onClick={() => this.props.modal('add-preparation-training')}
                secondary
              >
                Add
              </Button>}
          </div>
        </div>
        </div>
        <AwardPreparationTrainingsTable
          list={list}
          onRemove={awardId && this.handleRemoveModal}
          userDefined
        />
        <Modal id="add-preparation-training" customActions enableOverflow>
          <AddUserPreparationTraining
            awardId={awardId}
            collection={collection}
            addPreparationTraining={this.props.addPreparationTraining}
          />
        </Modal>
        <Modal id={`remove-preparation-training-${this.key}`} customActions>
          <div className="text--center">
            <Title h2 intlKey="moduleTitle.confirm">Confirm</Title>
          </div>
          <div className="row">
            <div className="col-xs-6">
              <Button
                intlKey="button.close"
                type="button"
                onClick={() => this.props.modal(null)}
                secondary
              >
                Close
              </Button>
            </div>
            <div className="col-xs-6 text--right">
              <Button
                intlKey="button.remove"
                type="button"
                onClick={() =>
                  this.props.removePreparationTraining(
                    awardId,
                    collection,
                    this.state.idToRemove
                  )}
                negative
              >
                Remove
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}
